import React from 'react';
import PropTypes from 'prop-types';

import { convertToLocaleDateTime } from '../../utils/components';
import { getTranslationForIso } from '../../utils/shared';

function getStatusName(statuses, statusId, language)
{
    if (statusId == null) { return '-'; }
    const status = statuses?.find(s => s.id === statusId);
     if (!status || !language) { return `#${statusId}`; }
    return getTranslationForIso(status.name, language) || `#${statusId}`;
}

const OrderStatusHistory = ({ history, statuses, language, translations, className }) =>
{
    if (!history || history.length === 0) {
        return (
            <fieldset className="col-12">
                <label>{translations?.caption || 'Historia statusów'}</label>
                <div>{translations?.empty || 'Brak historii statusów.'}</div>
            </fieldset>
        );
    }

    return (
        <fieldset className="col-12">
            <label>{translations?.caption || 'Historia statusów'}</label>

            <table className={className}>
                <thead>
                    <tr>
                        <th>{translations?.changeDate || 'Data zmiany'}</th>
                        <th>{translations?.previousStatus || 'Poprzedni status'}</th>
                        <th>{translations?.newStatus || 'Nowy status'}</th>
                        <th>{translations?.source || 'Źródło'}</th>
                        <th>{translations?.message || 'Komunikat'}</th>
                    </tr>
                </thead>
                <tbody>
                    {history.map(item => (
                        <tr key={item.id}>
                            <td>{convertToLocaleDateTime(item.changeDate)}</td>
                            <td>{getStatusName(statuses, item.previousOrderStatusId, language)}</td>
                            <td><strong>{getStatusName(statuses, item.orderStatusId, language)}</strong></td>
                            <td>{item.source || '-'}</td>
                            <td>{item.message || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </fieldset>
    );
};

OrderStatusHistory.propTypes =
{
    history: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        previousOrderStatusId: PropTypes.number,
        orderStatusId: PropTypes.number,
        changeDate: PropTypes.string,
        source: PropTypes.string,
        message: PropTypes.string,
    })),
    statuses: PropTypes.array,
    language: PropTypes.string,
    translations: PropTypes.object,
};

export default OrderStatusHistory;